import React from 'react'
import { ContentHeader } from '../layout/Content'

function FindAndReplaceHeader() {
  return ( <ContentHeader title='Find and Replace'/> );
}

export default React.memo(FindAndReplaceHeader)
